// Builds the small summary Farm OS hands to the farm-status GNOME top-bar
// extension (main.js writes it to $XDG_RUNTIME_DIR/farm-os-status.json).
//
// Counts and health only: no names, addresses or tokens, because the top bar
// is on show whenever the desktop is (screen shares, people walking past).
// Health uses the same rules as the front-page panel, so the two can't disagree.
import { buildChecks, summarize } from './commanderHealth';
import { isSubOrder } from './lostCustomers';

export const DESKTOP_STATUS_VERSION = 1;

const sameLocalDay = (a, b) =>
  a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();

function ordersSummary(data, now) {
  const recent = data?.recent_orders || [];
  const toPack = recent.filter(o => !o.fulfilled);
  // "Today" means purchases placed today, so subscription deliveries don't count
  const today = recent.filter(o => !isSubOrder(o) && o.timestamp && sameLocalDay(new Date(o.timestamp), now));
  const revenue = today.reduce((sum, o) => sum + (Number(o.total) || 0), 0);
  return {
    toPack: toPack.length,
    toPackSubscriptions: toPack.filter(isSubOrder).length,
    today: today.length,
    todayRevenue: Math.round(revenue * 100) / 100,
  };
}

function commanderSummary(payload) {
  const checks = buildChecks(payload);
  const { tone, headline } = summarize(checks);
  return {
    tone,
    headline,
    problems: checks
      .filter(c => c.tone === 'bad' || c.tone === 'warn')
      .map(({ label, tone: t, value }) => ({ label, tone: t, value })),
  };
}

// orders: GET /orders?days=N response, commander: GET /farm-commander/status
// response; either is null when its request failed.
export function buildDesktopStatus({ signedIn, orders = null, commander = null, errors = [], now = new Date() }) {
  return {
    version: DESKTOP_STATUS_VERSION,
    updatedAt: now.toISOString(),
    signedIn: !!signedIn,
    orders: orders ? ordersSummary(orders, now) : null,
    commander: commander ? commanderSummary(commander) : null,
    errors,
  };
}
